import { ModuleNames } from "@ag-grid-community/core";
import { CsvCreator } from "./csvExport/csvCreator";
import { GridSerializer } from "./csvExport/gridSerializer";
export var CsvExportModule = {
    moduleName: ModuleNames.CsvExportModule,
    beans: [CsvCreator, GridSerializer]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-community/csv-export/dist/es6/csvExportModule.js
// module id = 3099
// module chunks = 0